/**
 * Complementary products box (Burga-style "Shop the look")
 * ------------------------------------------------------------------
 * Finds sibling products with the same design (different device type) and
 * renders product cards with image, price and an AGGIUNGI (add-to-cart) button.
 *
 * 1) Predictive search by design name → resolve sibling handles (live products only).
 * 2) Per sibling fetch /products/{handle}.js → accurate image, price, first variant.
 * 3) AGGIUNGI → POST /cart/add.js.
 */
(function () {
  var DEVICE_TYPES = [
    // `it` = prefisso del titolo italiano ("Cover AirPods <design>"), vedi CLAUDE.md "Traduzioni italiane"
    { suffix: 'Tough iPhone Case', it: 'Cover iPhone Tough', label: 'Cover iPhone' },
    { suffix: 'AirPods Case',      it: 'Cover AirPods',      label: 'AirPods' },
    { suffix: 'AirPods Max Case',  it: 'Cover AirPods Max',  label: 'AirPods Max' }
  ];

  function shopRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) return window.Shopify.routes.root;
    return '/';
  }
  function isType(dt, type) {
    return norm(dt.suffix) === norm(type) || norm(dt.it) === norm(type);
  }

  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function money(cents) {
    try {
      return new Intl.NumberFormat('it-IT', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format((cents || 0) / 100);
    } catch (e) { return ((cents || 0) / 100).toFixed(2) + ' €'; }
  }
  function esc(s) { return (s || '').replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

  class ComplementaryProductsBox extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.designName = this.dataset.designName || '';
      this.currentType = this.dataset.currentType || '';
      this.grid = this.querySelector('.cls-compbox__grid');
      if (!this.designName || !this.grid) return;
      this.load();
    }

    async load() {
      var siblings = [];
      try {
        var url = shopRoot().replace(/\/$/, '') +
          '/search/suggest.json?q=' + encodeURIComponent(this.designName) +
          '&resources[type]=product&resources[limit]=10' +
          '&resources[options][unavailable_products]=last';
        var res = await fetch(url, { headers: { 'Accept': 'application/json' } });
        if (res.ok) {
          var data = await res.json();
          var products = (((data || {}).resources || {}).results || {}).products || [];
          var self = this;
          DEVICE_TYPES.forEach(function (dt) {
            if (isType(dt, self.currentType)) return; // skip current device
            var expected = [norm(self.designName + ' ' + dt.suffix), norm(dt.it + ' ' + self.designName)];
            for (var i = 0; i < products.length; i++) {
              if (expected.indexOf(norm(products[i].title)) !== -1) {
                siblings.push({ url: (products[i].url || '').split('?')[0], label: dt.label });
                break;
              }
            }
          });
        }
      } catch (e) { /* silent */ }

      if (!siblings.length) return; // nothing to show → stays hidden

      // Fetch accurate product data (image, price, variant) per sibling.
      var cards = await Promise.all(siblings.map(function (s) {
        return fetch(s.url + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) { return p ? { p: p, label: s.label } : null; })
          .catch(function () { return null; });
      }));
      cards = cards.filter(Boolean);
      if (!cards.length) return;

      this.render(cards);
      this.removeAttribute('hidden');
    }

    render(cards) {
      var html = cards.map(function (c) {
        var p = c.p;
        var variant = (p.variants || []).filter(function (v) { return v.available; })[0] || (p.variants || [])[0];
        var img = (p.featured_image) || (p.images && p.images[0]) || '';
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        var imgSized = img ? img.replace(/(\.[a-z]+)(\?.*)?$/i, '_360x$1$2') : '';
        var vid = variant ? variant.id : '';
        return '' +
          '<div class="cls-compcard">' +
            '<a class="cls-compcard__media" href="' + esc(p.url) + '">' +
              (imgSized ? '<img src="' + esc(imgSized) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
            '</a>' +
            '<div class="cls-compcard__body">' +
              '<span class="cls-compcard__type">' + esc(c.label) + '</span>' +
              '<a class="cls-compcard__name" href="' + esc(p.url) + '" style="text-decoration:none;color:inherit;">' + esc(p.title) + '</a>' +
              '<span class="cls-compcard__price">' + money(p.price) + '</span>' +
              '<button type="button" class="cls-compcard__btn" data-variant-id="' + vid + '"' + (vid ? '' : ' disabled') + '>AGGIUNGI</button>' +
            '</div>' +
          '</div>';
      }).join('');

      this.grid.innerHTML = html;
      this.grid.querySelectorAll('.cls-compcard__btn').forEach(function (btn) {
        btn.addEventListener('click', function () { onAdd(btn); });
      });
    }
  }

  async function onAdd(btn) {
    var vid = btn.getAttribute('data-variant-id');
    if (!vid || btn.disabled) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';
    try {
      var res = await fetch(shopRoot().replace(/\/$/, '') + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add failed');
      btn.textContent = '✓ Aggiunto';
      btn.classList.add('is-added');
      // refresh cart UI if the theme exposes a bus/section renderer
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (window.FoxTheme && window.FoxTheme.pubsub && window.FoxTheme.PUB_SUB_EVENTS) {
        window.FoxTheme.pubsub.publish(window.FoxTheme.PUB_SUB_EVENTS.cartUpdate, {});
      }
      setTimeout(function () { btn.textContent = original; btn.classList.remove('is-added'); btn.disabled = false; }, 2200);
    } catch (e) {
      btn.textContent = 'Riprova';
      setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1800);
    }
  }

  if (!customElements.get('complementary-products-box')) {
    customElements.define('complementary-products-box', ComplementaryProductsBox);
  }
})();
